import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M4.5 3.43A2 2 0 0 1 3 2.74L2 1.59 3.5.256l1 1.162.628-.724A1.97 1.97 0 0 1 7.148.07C8.168.334 9.25 1.35 9.25 2.687h-2c0-.329-.407-.62-.617-.678L6 2.738a2 2 0 0 1-1.5.691",
      class: "fill-primary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M9.25 4.52v-.568h-2v.57a5.75 5.75 0 0 0-3.562 2.176 5.806 5.806 0 0 0 .678 7.783A5.73 5.73 0 0 0 8.25 16a5.73 5.73 0 0 0 3.884-1.519 5.806 5.806 0 0 0 .678-7.783A5.75 5.75 0 0 0 9.25 4.523zm-1 9.537c-1.003 0-1.966-.401-2.676-1.115a3.816 3.816 0 0 1 0-5.381 3.77 3.77 0 0 1 5.348-.001 3.8 3.8 0 0 1 1.108 2.688 3.8 3.8 0 0 1-1.107 2.688 3.77 3.77 0 0 1-2.673 1.113z",
      class: "fill-secondary"
    }, null, -1)
  ])))
}
export default { render: render }